"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _dashboard = require("@/api/dashboard");
var _index = _interopRequireDefault(require("@/components/echarts/index"));
var _permission = require("@/utils/permission");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 权限判断函数
var _default = exports.default = {
  components: {
    echartsFrom: _index.default
  },
  data: function data() {
    return {
      infoList: null,
      visitDate: 'last30',
      series: [],
      xAxis: [],
      info: {},
      legendData: [],
      yAxisData: []
    };
  },
  mounted: function mounted() {
    this.yAxisData = [{
      type: 'value',
      name: '金额',
      axisLine: {
        show: false
      },
      axisTick: {
        show: false
      },
      axisLabel: {
        textStyle: {
          color: '#7F8B9C'
        }
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: '#F5F7F9'
        }
      }
    }, {
      type: 'value',
      name: '数量',
      axisLine: {
        show: false
      },
      axisTick: {
        show: false
      },
      axisLabel: {
        textStyle: {
          color: '#7F8B9C'
        }
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: '#F5F7F9'
        }
      }
      // axisLabel: {
      //     formatter: '{value} °C'
      // }
    }];
  },
  methods: {
    checkPermi: _permission.checkPermi,
    radioChange: function radioChange(val) {
      switch (val) {
        case 'week':
          this.handleChangeWeek();
          break;
        case 'month':
          this.handleChangeMonth();
          break;
        case 'year':
          this.handleChangeYear();
          break;
        default:
          this.handleChangeVisitType();
          break;
      }
    },
    // 时间改变
    handleChangeVisitType: function handleChangeVisitType() {
      var _this = this;
      this.xAxis = [];
      this.legendData = [];
      (0, _dashboard.chartOrder30Api)().then(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(res) {
          var pices, qualitys, key, _key;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _this.info = res;
                pices = [];
                qualitys = [];
                for (key in res.price) {
                  pices.push(Number(res.price[key]));
                  _this.xAxis.push(key);
                }
                for (_key in res.quality) {
                  qualitys.push(Number(res.quality[_key]));
                }
                _this.legendData = ['订单金额', '订单数'];
                _this.series = [{
                  name: '订单金额',
                  type: 'bar',
                  itemStyle: {
                    normal: {
                      color: '#5B8FF9'
                    }
                  },
                  data: pices
                }, {
                  name: '订单数',
                  type: 'line',
                  smooth: true,
                  itemStyle: {
                    normal: {
                      color: '#4BCAD5'
                    }
                  },
                  yAxisIndex: 1,
                  data: qualitys
                }];
              case 7:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    handleChangeWeek: function handleChangeWeek() {
      var _this2 = this;
      this.xAxis = [];
      this.legendData = [];
      (0, _dashboard.chartOrderWeekApi)().then(/*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(res) {
          var prePrice, price, qualitys, preQuality, key, _key2, _key3, _key4;
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                _this2.info = res;
                _this2.legendData = ['上周金额', '本周金额', '上周订单数', '本周订单数'];
                prePrice = [];
                price = [];
                qualitys = [];
                preQuality = [];
                for (key in res.prePrice) {
                  prePrice.push(Number(res.prePrice[key]));
                  _this2.xAxis.push(key);
                }
                for (_key2 in res.price) {
                  price.push(Number(res.price[_key2]));
                }
                for (_key3 in res.preQuality) {
                  preQuality.push(Number(res.preQuality[_key3]));
                }
                for (_key4 in res.quality) {
                  qualitys.push(Number(res.quality[_key4]));
                }
                _this2.series = [{
                  name: '上周金额',
                  type: 'bar',
                  itemStyle: {
                    normal: {
                      color: '#5B8FF9'
                    }
                  },
                  data: prePrice
                }, {
                  name: '本周金额',
                  type: 'bar',
                  itemStyle: {
                    normal: {
                      color: '#4BCAD5'
                    }
                  },
                  data: price
                }, {
                  name: '上周订单数',
                  type: 'line',
                  smooth: true,
                  itemStyle: {
                    normal: {
                      color: '#E6A23C'
                    }
                  },
                  yAxisIndex: 1,
                  data: preQuality
                }, {
                  name: '本周订单数',
                  type: 'line',
                  smooth: true,
                  itemStyle: {
                    normal: {
                      color: '#768A9C'
                    }
                  },
                  yAxisIndex: 1,
                  data: qualitys
                }];
              case 11:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }());
    },
    handleChangeMonth: function handleChangeMonth() {
      var _this3 = this;
      this.xAxis = [];
      this.legendData = [];
      (0, _dashboard.chartOrderMonthApi)().then(/*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(res) {
          var prePrice, price, qualitys, preQuality, key, _key5, _key6, _key7;
          return _regeneratorRuntime().wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                _this3.info = res;
                _this3.legendData = ['上月金额', '本月金额', '上月订单数', '本月订单数'];
                prePrice = [];
                price = [];
                qualitys = [];
                preQuality = [];
                for (key in res.prePrice) {
                  prePrice.push(Number(res.prePrice[key]));
                  _this3.xAxis.push(key);
                }
                for (_key5 in res.price) {
                  price.push(Number(res.price[_key5]));
                }
                for (_key6 in res.preQuality) {
                  preQuality.push(Number(res.preQuality[_key6]));
                }
                for (_key7 in res.quality) {
                  qualitys.push(Number(res.quality[_key7]));
                }
                _this3.series = [{
                  name: '上月金额',
                  type: 'bar',
                  itemStyle: {
                    normal: {
                      color: '#5B8FF9'
                    }
                  },
                  data: prePrice
                }, {
                  name: '本月金额',
                  type: 'bar',
                  itemStyle: {
                    normal: {
                      color: '#4BCAD5'
                    }
                  },
                  data: price
                }, {
                  name: '上月订单数',
                  type: 'line',
                  smooth: true,
                  itemStyle: {
                    normal: {
                      color: '#E6A23C'
                    }
                  },
                  yAxisIndex: 1,
                  data: preQuality
                }, {
                  name: '本月订单数',
                  type: 'line',
                  smooth: true,
                  itemStyle: {
                    normal: {
                      color: '#768A9C'
                    }
                  },
                  yAxisIndex: 1,
                  data: qualitys
                }];
              case 11:
              case "end":
                return _context3.stop();
            }
          }, _callee3);
        }));
        return function (_x3) {
          return _ref3.apply(this, arguments);
        };
      }());
    },
    handleChangeYear: function handleChangeYear() {
      var _this4 = this;
      this.xAxis = [];
      this.legendData = [];
      (0, _dashboard.chartOrderYearApi)().then(/*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(res) {
          var prePrice, price, qualitys, preQuality, key, _key8, _key9, _key10;
          return _regeneratorRuntime().wrap(function _callee4$(_context4) {
            while (1) switch (_context4.prev = _context4.next) {
              case 0:
                _this4.info = res;
                _this4.legendData = ['去年金额', '今年金额', '去年订单数', '今年订单数'];
                prePrice = [];
                price = [];
                qualitys = [];
                preQuality = [];
                for (key in res.prePrice) {
                  prePrice.push(Number(res.prePrice[key]));
                  _this4.xAxis.push(key);
                }
                for (_key8 in res.price) {
                  price.push(Number(res.price[_key8]));
                }
                for (_key9 in res.preQuality) {
                  preQuality.push(Number(res.preQuality[_key9]));
                }
                for (_key10 in res.quality) {
                  qualitys.push(Number(res.quality[_key10]));
                }
                _this4.series = [
                ////let col = ["#B37FEB", "#FFAB2B", "#1890FF", "#00C050"];
                {
                  name: '去年金额',
                  type: 'bar',
                  itemStyle: {
                    normal: {
                      color: '#5B8FF9'
                    }
                  },
                  data: prePrice
                }, {
                  name: '今年金额',
                  type: 'bar',
                  itemStyle: {
                    normal: {
                      color: '#4BCAD5'
                    }
                  },
                  data: price
                }, {
                  name: '去年订单数',
                  type: 'line',
                  smooth: true,
                  itemStyle: {
                    normal: {
                      color: '#E6A23C'
                    }
                  },
                  yAxisIndex: 1,
                  data: preQuality
                }, {
                  name: '今年订单数',
                  type: 'line',
                  smooth: true,
                  itemStyle: {
                    normal: {
                      color: '#768A9C'
                    }
                  },
                  yAxisIndex: 1,
                  data: qualitys
                }];
              case 11:
              case "end":
                return _context4.stop();
            }
          }, _callee4);
        }));
        return function (_x4) {
          return _ref4.apply(this, arguments);
        };
      }());
    },
    // 监听页面宽度变化，刷新表格
    handleResize: function handleResize() {
      if (this.infoList) this.$refs.visitChart.handleResize();
    }
  },
  created: function created() {
    this.handleChangeVisitType();
  }
};